import { render, staticRenderFns } from "./StripeNewCard.vue?vue&type=template&id=167081d3"
import script from "./StripeNewCard.vue?vue&type=script&lang=js"
export * from "./StripeNewCard.vue?vue&type=script&lang=js"
import style0 from "./StripeNewCard.vue?vue&type=style&index=0&id=167081d3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports